import React, { useRef, useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import palette from '../../../lib/styles/palette';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_PCGirder } from '../../../lib/data/standard-weight';

const PCGirderForm = ({ onSaveStructure, onChangeWeightSummary, girders, beltWidth }) => {
    const [isShow, setIsShow] = useState(girders?.length || false);
    const [newGirder, setNewGirder] = useState(girders || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [deckCategory, setDeckCategory] = useState('');
    const [densityCategory, setDensityCategory] = useState('');
    const [spanCategory, setSpanCategory] = useState('');
    const [span, setSpan] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* standard weight library에서 해당 벨트폭을 뽑아서 저장한다. */
    // const [weightLibrary, setWeightLibrary] = useState('');
    const weightLibrary = useRef(null); // chatGPT가 알려준 내용

    /* category 설명하는 text */
    const deckCategoryText = useRef({
        0: 'Deck Plate 無',
        1: 'Deck Plate 有',
    });

    const densityCategoryText = useRef({
        0: '1.0 이하',
        1: '1.0초과 2.0이하',
        2: '2.0 초과',
    });

    const spanCategoryText = useRef({
        0: '10m 이하',
        1: '10m 초과 15m 이하',
        2: '15m 초과 20m 이하',
        3: '20m 초과',
    });

    /*  처음 props로 넘어온 girders를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialGirder = useRef(girders ? girders : []);
    // const initialGirder = useRef(girders || []);

    /* 벨트폭에 해당하는 Weight Table을 가져온다. */
    useEffect(() => {
        if (!standardWeight_PCGirder || !beltWidth) return;
        const library = standardWeight_PCGirder.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        weightLibrary.current = library;
    }, [beltWidth]);

    /* 기준 중량 가져오기 함수 */
    const getStandardWeight = useCallback((deckCategory, densityCategory, span) => {
        if (!weightLibrary.current) return;

        const spanCategory = span < 6 ? 0 : span < 10 ? 1 : span < 15 ? 2 : span < 20 ? 3 : span < 25 ? 4 : 5;
        setSpanCategory(spanCategory);

        const index = deckCategory * 6 + spanCategory * 1;

        return weightLibrary.current.standardWeight[index];
    }, []);

    /* 기준 중량 가져오기 */
    useEffect(() => {
        if (!span) return;
        setStandardWeight(getStandardWeight(Number(deckCategory), Number(densityCategory), Number(span)));
    }, [getStandardWeight, span, deckCategory, densityCategory]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!span || !standardWeight || !factor || !qty) {
        //     return;
        // }
        // const calculatedUnitWeight = Math.ceil(span * standardWeight * factor);
        const _unitWeight = Math.ceil(standardWeight * span * factor);
        setUnitWeight(_unitWeight);
    }, [factor, span, standardWeight]);

    useEffect(() => {
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 girder ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newGirder.length) {
            return 0;
        }
        /*
        const lastGirder = newGirder.reduce((accumulator, currentValue) => {
            const currentId = currentValue.id.substring(3);
            const accumulatorId = accumulator.id.substring(3);
            if (currentId> accumulatorId) {
                return currentValue;
            }
            return accumulator;
        });
        return lastGirder.id.substring(3);
        */
        /* ChatGPT가 알려준 함수. 한줄로 정리가 되네....ㅋ */
        return Math.max(...newGirder.map((girder) => Number(girder.id.substring(3))), 0);
    }, [newGirder]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`GR-${getLastId() * 1 + 1}`);
        // setDeckCategory('');
        // setDensityCategory('');
        setSpanCategory('');
        setSpan('');
        setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((girders) => {
        const total = girders.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(total);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((girders) => {
        const total = girders.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(total);
    }, []);

    /* 추가 버튼을 누르면 newGirder에 girder 추가 */
    const onAddGirder = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const girder = {
            id,
            deckCategory: deckCategoryText.current[`${deckCategory}`],
            densityCategory: densityCategoryText.current[`${densityCategory}`],
            spanCategory: spanCategoryText.current[`${spanCategory}`],
            span,
            standardWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewGirder((prev) => [...prev, girder]);
        setIsChanged(true);
    }, [deckCategory, densityCategory, factor, id, qty, span, spanCategory, standardWeight, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 girder 삭제 */
    const onDeleteGirder = useCallback((id) => {
        // setNewGirder(newGirder.filter(girder => girder.id !== id));
        // chatGPT가 알려준 방법. 이렇게 해야 newGirder를 의존성 배열에서 없앨 수 있다.
        setNewGirder((prev) => prev.filter((girder) => girder.id !== id));
        setIsChanged(true);
    }, []);

    /* newGirder에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        /* 이 부분이 onAddGirder 함수안으로 들어가면 제대로 작동하지 않음. */
        getTotalQty(newGirder);
        getTotalWeight(newGirder);
        initializeForm();
        /* 여기까지 */

        onSaveStructure({
            key: 'girder',
            value: newGirder,
        });
        onChangeWeightSummary({
            key: 'girder',
            // value: getTotalWeight(),
            value: {
                totalQty,
                totalWeight,
            },
        });
        // setIsChanged(true);
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newGirder,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveGirder = useCallback(() => {
    //     setNewGirder(initialGirder.current);
    //     onSaveStructure({
    //         key: 'girder',
    //         value: newGirder,
    //     });
    //     onChangeWeightSummary({
    //         key: 'girder',
    //         // value: getTotalWeight(),
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newGirder, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newGirder를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewGirder(initialGirder.current);
    //     onSaveStructure({
    //         key: 'girder',
    //         // value: newGirder,
    //         value: initialGirder.current, // chatGPT가 알려준 방법. 이렇게 해야 newGirder를 의존성배열에서 삭제할 수 있다.
    //     });
    //     onChangeWeightSummary({
    //         key: 'girder',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <PCGirderFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Pipe Conveyor Girder</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>DeckPlate</th>
                                {/* <th>Density <br/> (ton/m3)</th> */}
                                {/* <th>Category-III</th> */}
                                <th>Span (m)</th>
                                <th>
                                    Standard W't <br />
                                    (kg/m)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit W't <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newGirder &&
                                newGirder.map((girder, index) => (
                                    <tr key={index}>
                                        <td className="id">{girder.id}</td>
                                        <td className="id">{girder.deckCategory}</td>
                                        {/* <td className="id">{girder.densityCategory}</td> */}
                                        {/* <td className="id">{girder.spanCategory}</td> */}
                                        <td className="span">{girder.span}</td>
                                        <td className="s-weight">{girder.standardWeight}</td>
                                        <td className="qty">{girder.factor}</td>
                                        <td>{girder.unitWeight}</td>
                                        <td className="qty">{girder.qty}</td>
                                        <td>{girder.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteGirder(girder.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="deckCategory"
                                                value="0"
                                                onChange={(e) => setDeckCategory(e.target.value)}
                                            />
                                            <span>No</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="deckCategory"
                                                value="1"
                                                onChange={(e) => setDeckCategory(e.target.value)}
                                            />
                                            <span>Yes</span>
                                        </label>
                                    </div>
                                </td>
                                {/*<td>
                                <div className="input-radio">
                                    <label><input type="radio" name="densityCategory" value="0" onChange={(e) => setDensityCategory(e.target.value)} /><span>γ ≤ 1</span></label>
                                    <label><input type="radio" name="densityCategory" value="1" onChange={(e) => setDensityCategory(e.target.value)} /><span>1 ＜ γ ≤ 2</span></label>
                                    <label><input type="radio" name="densityCategory" value="2" onChange={(e) => setDensityCategory(e.target.value)} /><span>2 ＜ γ </span></label>
                                </div>
                            </td>*/}
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={span}
                                        onChange={(e) => setSpan(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={standardWeight}
                                        onChange={(e) => setStandardWeight(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                {/* <td><StyledInput readOnly value={unitWeight} /></td> */}
                                {/* <td><StyledInput readOnly value={weight}  /></td> */}
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddGirder}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>PC Girder Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveGirder} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </PCGirderFormBlock>
    );
};

export default PCGirderForm;

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const PCGirderFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%; // 이 코드때문에 table이 꽉 차게 나오는 것임.
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
        // background-color: ${palette.gray[0]}
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
        // background-color: ${palette.gray[0]}
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
    .right-align {
        text-align: right;
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;
